<template>
    <div>
        <report-header
            :title="title"
        />
        <b-card id="report-card">
            <div id="report-body" class="w-100">
                <QTable
                    :data="result"
                    :columns="formattedColumns"
                    :hide-bottom="true"
                    :rows-per-page-options="[0]"
                    row-key="item_id"
                    :loading="isLoading"
                    class="q-table"
                >
                    <template v-slot:bottom-row>
                        <q-tr
                            v-if="result.length == 0 && !isLoading && !isError"
                        >
                            <q-td colspan="8">No records available</q-td>
                        </q-tr>
                    </template>
                    <template v-slot:header-cell="{ col }">
                        <th>
                            <strong>{{ col.label }}</strong>
                        </th>
                    </template>
                    <template v-slot:body-cell-item="props">
                        <q-td :props="props">
                            <item-name
                                :item="{
                                    name: props.row.item,
                                    encodedId: props.row.item_encoded_id
                                }"
                            />
                        </q-td>
                    </template>
                </QTable>
            </div>
        </b-card>
    </div>
</template>
<script>
import { QTable } from "quasar";
import "@/css/quasar-table.css";
import Report from "@/mixins/report.js";
import ReportService from "@/services/report";
import CREPORT from "@/constants/report";
import ItemName from "@/components/commons/item-name";

export default {
    components: {
        QTable,
        ItemName,
        ReportHeader: () => import("@/components/report/report-header")
    },
    mixins: [Report],
    props: {
        data: {
            type: Object,
            default() {
                return {
                    start: this.getStartDate("week"),
                    end: this.getEndDate("day")
                };
            }
        },
        dialogs: {
            type: Object,
            default() {
                return {};
            }
        }
    },
    data() {
        return {
            isLoading: true,
            isError: false,
            result: [],
            title: "Inventory Alerts"
        };
    },
    mounted() {
        let self = this;
        self.data.isShowItemStatus = true;
        self.data.filterDateOption = true;
        self.data.status = 2;
        self._getSetting().then(() => {
            self.init();
        });

        self.$root.$on("report-filter-date-range:refresh", function (params) {
            if (params) {
                self.data.status = params.status;
            }
            self.init();
        });
    },
    beforeDestroy: function () {
        this.data.filterDateOption = true;
        this.$root.$off("report-filter-date-range:refresh", this.init);
    },
    computed: {
        formattedColumns() {
            return [
                {
                    name: "item",
                    label: "Item",
                    field: "item",
                    align: "left",
                    style: "width: 30%"
                },
                {
                    name: "type",
                    label: "Type",
                    field: "type",
                    align: "left",
                    format: (val, row) => {
                        return val.replace("_", " ");
                    },
                    style: "width: 10%",
                    classes: "text-capitalize"
                },
                {
                    name: "lot",
                    label: "Lot",
                    field: "lot",
                    align: "left",
                    style: "width: 10%"
                },
                {
                    name: "balance",
                    label: "Balance",
                    field: "balance",
                    align: "left",
                    style: "width: 10%"
                },
                {
                    name: "expire",
                    label: "Expire",
                    field: "expire",
                    align: "left",
                    style: "width: 10%"
                },
                {
                    name: "notes",
                    label: "Notes",
                    field: "notes",
                    align: "left",
                    style: "width: 30%"
                }
            ];
        }
    },
    methods: {
        async init(params) {
            let self = this;
            self.isLoading = true;
            self.isError = false;

            if (params) {
                this.data.status = params.status;
            }

            await ReportService.getReport(CREPORT.TYPE.INVENTORY_ALERTS, 
                {
                    status: params ? params.status : this.data.status
                }
            )
                .then(res => {
                    if (res && res.message && res.message.code === 200) {
                        self.result = res.resource.results;
                        self.title = res.resource.meta.title;
                        self.dynamicPageTitle(self.title);
                        self.isLoading = false;
                    } else {
                        throw new Error("Error: Unable to get the report.");
                    }
                })
                .catch(e => {
                    console.error(e.message);
                    self.isLoading = false;
                    self.isError = true;
                    self._message("Error: Unable to get the report", "danger");
                });
        }
    }
};
</script>
